import { render, staticRenderFns } from "./CustomOrderList.vue?vue&type=template&id=0d3e0371&scoped=true"
import script from "./CustomOrderList.vue?vue&type=script&lang=js"
export * from "./CustomOrderList.vue?vue&type=script&lang=js"
import style0 from "./CustomOrderList.vue?vue&type=style&index=0&id=0d3e0371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e0371",
  null
  
)

export default component.exports